<template>
  <div class="outside-copyright text-center">
    <p class="font-16-500 terms-text">
      By continuing, you agree to GoFindBuild LLC
    </p>
    <p class="font-16-500 terms-text">
      <span class="text-center">
        <router-link to="/terms">Terms of Service</router-link>
      </span>
      &
      <span class="text-center">
        <router-link to="/privacy-policy">Privacy Policy</router-link>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "login-footer",
}
</script>

<style scoped>
.terms-text {
  color: var(--Gray-500, #677690);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0;

  span {
    a {
      color: var(--Gray-800, #3a4252);
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      text-decoration: none;
    }
  }
}
</style>
